const defaultMapStyle = (ordinalSource, selectedIds) => ({
    version: 8,
    metadata: {
        'mapbox:autocomposite': true,
        'mapbox:type': 'template',
        'mapbox:sdk-support': {
            js: '0.50.0',
            android: '6.7.0',
            ios: '4.6.0',
        },
        'mapbox:groups': {},
    },
    center: [-79.93644098323023, 36.10490606002804],
    light: {
        intensity: 0.1,
        color: 'hsl(0, 0%, 100%)',
    },
    sprite: 'https://content.locuslabs.com/airport/spritesheet-mapbox/spritesheet',
    glyphs: 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf',
    layers: [{
            id: 'background',
            type: 'background',
            paint: { 'background-color': 'hsl(0, 0%, 95%)' },
            source: '',
        }, {
            id: 'basemap',
            type: 'fill',
            source: 'landscape-background',
            filter: ['all', ['match', ['get', 'aiLayer'], ['concrete', 'runways', 'structures'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-color': ['interpolate', ['linear'], ['zoom'], 18.5, ['get', 'fillColor'], 19.5, ['get', 'fillColor']],
                'fill-opacity': ['interpolate', ['linear'], ['zoom'], 0, 1, 19, 1, 20, 0],
            },
        }, {
            id: 'parking',
            type: 'fill-extrusion',
            source: 'landscape-background',
            filter: ['all', ['match', ['get', 'aiLayer'], ['parking'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-extrusion-height': 10,
                'fill-extrusion-color': ['interpolate', ['linear'], ['zoom'], 15.5, 'hsl(0, 0%, 78%)', 16, ['get', 'fillColor']],
            },
        }, {
            id: 'basemap.curb',
            type: 'fill',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'category'], ['basemap.curb'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-color': ['get', 'fillColor'],
                'fill-opacity': 1,
                'fill-outline-color': 'hsla(0, 0%, 0%, 0)',
            },
        }, {
            id: 'jetway arm',
            type: 'line',
            source: 'landscape-background',
            filter: ['all', ['match', ['get', 'aiLayer'], ['jetways'], true, false], ['match', ['get', 'category'], ['jetway', 'basemap.jetway'], true, false], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-color': ['get', 'strokeColor'],
                'line-width': ['interpolate', ['exponential', 1.8], ['zoom'], 0, 3, 22, 100],
                'line-opacity': ['interpolate', ['linear'], ['zoom'], 1, 1, 15, 0, 19, 1, 20, 0],
            },
        }, {
            id: 'jetway bubble',
            type: 'fill',
            source: 'landscape-background',
            filter: ['all', ['match', ['get', 'category'], ['jetway.bubble', 'basemap.jetwaybubble'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-color': ['get', 'fillColor'],
                'fill-opacity': ['interpolate', ['linear'], ['zoom'], 15.5, 0, 16.5, 1, 18.5, 1, 19.5, 0],
            },
        }, {
            id: 'outline',
            type: 'line',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'aiLayer'], ['outline'], true, false], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-color': ['get', 'strokeColor'],
                'line-width': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 1, 22, 8],
                'line-opacity': ['interpolate', ['linear'], ['zoom'], 16.5, 0, 17.5, 0.5],
            },
        }, {
            id: 'ailayer-outline',
            type: 'fill',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'aiLayer'], ['outline'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: { 'fill-color': ['get', 'fillColor'] },
        }, {
            id: 'non-accessible',
            type: 'fill-extrusion',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'category'], ['element.nonaccessible', 'non accessible'], true, false], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-extrusion-height': 1,
                'fill-extrusion-color': ['step', ['zoom'], 'hsl(0, 0%, 78%)', 16.5, 'hsl(0, 0%, 78%)', 17, ['get', 'fillColor']],
                'fill-extrusion-opacity': ['interpolate', ['linear'], ['zoom'], 1, 0, 17.5, 1],
            },
        }, {
            id: 'nonaccessible outline',
            type: 'line',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'aiLayer'], ['non-accessible', 'misc'], true, false], ['match', ['get', 'category'], ['security.exit', 'element.presecurity', 'security.checkpoint', 'element.securitythreshold', 'element.postsecurity', 'basemap.curb', 'element.arrows'], false, true], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-color': ['step', ['zoom'], 'hsl(0, 0%, 78%)', 16.5, 'hsl(0, 0%, 78%)', 17, ['get', 'strokeColor']],
                'line-width': ['interpolate', ['exponential', 1.7], ['zoom'], 0, 1, 22, 8],
                'line-opacity': 0.1,
            },
        }, {
            id: 'poi polygons',
            type: 'fill-extrusion',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'aiLayer'], ['poi'], true, false], ['match', ['get', 'category'], ['lounge', 'element.door', 'door'], false, true], ['!=', ['get', 'isTouch'], true], ['match', ['geometry-type'], ['Polygon'], true, false]],
            layout: {},
            paint: {
                'fill-extrusion-color': ['step', ['zoom'], 'hsl(0, 0%, 78%)', 16.5, 'hsl(0, 0%, 78%)', 17, ['get', 'fillColor']],
                'fill-extrusion-height': 1,
                'fill-extrusion-opacity': 1,
            },
        }, {
            id: 'poi outline',
            type: 'line',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'aiLayer'], ['poi'], true, false], ['match', ['get', 'category'], ['security.exit', 'element.presecurity', 'security.checkpoint', 'element.securitythreshold', 'element.postsecurity', 'basemap.curb', 'element.arrows', 'door'], false, true], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-color': ['step', ['zoom'], 'hsl(0, 0%, 78%)', 16.5, 'hsl(0, 0%, 78%)', 17, ['get', 'strokeColor']],
                'line-width': ['interpolate', ['exponential', 1.7], ['zoom'], 0, 1, 22, 8],
                'line-opacity': 0.05,
            },
        }, {
            id: 'roads',
            type: 'line',
            source: 'landscape-background',
            filter: ['all', ['match', ['get', 'aiLayer'], ['roads'], true, false], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-color': ['interpolate', ['linear'], ['zoom'], 15.5, 'hsl(0, 0%, 78%)', 16, ['get', 'strokeColor']],
                'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 0, 1, 22, 30],
                'line-opacity': ['interpolate', ['linear'], ['zoom'], 18, 1, 19, 0],
            },
        }, {
            id: 'door',
            type: 'line',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'category'], ['element.door', 'door'], true, false], ['match', ['geometry-type'], ['LineString'], true, false], ['match', ['geometry-type'], ['Point'], false, true]],
            layout: {},
            paint: {
                'line-width': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 0.5, 22, 30],
                'line-color': ['get', 'strokeColor'],
                'line-opacity': ['interpolate', ['linear'], ['zoom'], 16.5, 0, 17.5, 0.7],
            },
        }, {
            id: 'ailayer-fill',
            type: 'fill-extrusion',
            source: ordinalSource,
            filter: ['match', ['geometry-type'], ['Polygon'], true, false],
            layout: {},
            paint: {
                'fill-extrusion-height': 20,
                'fill-extrusion-color': 'hsl(222, 0%, 65%)',
                'fill-extrusion-opacity': ['interpolate', ['exponential', 1.96], ['zoom'], 15, 1, 16, 0],
                'fill-extrusion-base': 0,
            },
        }, {
            id: 'selected - polygon circle',
            type: 'circle',
            source: ordinalSource,
            minzoom: 19,
            filter: ['all', ['match', ['get', 'id'], selectedIds, true, false], ['==', ['get', 'showBadge'], true]],
            layout: {},
            paint: {
                'circle-stroke-color': 'hsla(0, 0%, 0%, 0)',
                'circle-stroke-width': 1,
                'circle-color': 'hsl(0, 0%, 100%)',
                'circle-translate': [0, 0],
                'circle-radius': 28,
            },
        }, {
            id: '3 - point pois no text',
            type: 'symbol',
            source: ordinalSource,
            minzoom: 19,
            filter: ['all', ['match', ['get', 'aiLayer'], ['poi'], true, false], ['==', ['get', 'showBadge'], true], ['match', ['get', 'category'], ['', 'checkin', 'checkin.curbside', 'ticketing.selfcheckinkiosk', 'security.checkpoint', 'portal.stairs', 'portal.elevator', 'portal.escalator'], false, true], ['match', ['geometry-type'], ['Point'], true, false]],
            layout: {
                'icon-offset': [0, 0],
                'icon-image': ['get', 'category'],
                'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
                'text-padding': 0,
                'text-offset': [0, 0],
                'icon-size': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 0.5, 20, 1.2],
            },
            paint: {
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'text-halo-blur': 0,
                'text-halo-width': 1.25,
                'text-color': 'hsl(0, 0%, 1%)',
                'icon-opacity': ['interpolate', ['linear'], ['zoom'], 16.5, 0, 17, 1],
            },
        }, {
            id: '2 - priority point pois',
            type: 'symbol',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'category'], ['door', 'portal.stairs', 'portal.elevator', 'portal.escalator', 'checkin', 'ticketing.selfcheckinkiosk', 'checkin.curbside', 'security.exit', 'security.checkpoint', 'gate'], true, false], ['match', ['get', 'category'], ['', 'security.exit', 'security.checkpoint', 'label.floor'], false, true], ['match', ['geometry-type'], ['Point'], true, false]],
            layout: {
                'text-size': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 12, 22, 30],
                'icon-offset': [0, 0],
                'icon-image': ['get', 'category'],
                'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
                'text-padding': 0,
                'text-offset': [0, 1],
                'icon-size': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 0.5, 20, 1.2],
                'text-anchor': 'top',
                'text-field': ['to-string', ['get', 'text']],
                'text-max-width': 5,
            },
            paint: {
                'text-opacity': ['interpolate', ['linear'], ['zoom'], 18.5, 0, 19, 1],
                'text-halo-blur': 0.25,
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'icon-opacity': ['interpolate', ['exponential', 1], ['zoom'], 17, 0, 17.5, 1],
                'text-halo-width': 1,
            },
        }, {
            id: '2 - polygon pois',
            type: 'symbol',
            source: ordinalSource,
            filter: ['all', ['match', ['get', 'category'], ['security.exit', 'element.presecurity', 'security.checkpoint', 'element.securitythreshold', 'element.postsecurity', 'gate', 'checkin', 'checkin.curbside', 'ticketing.selfcheckinkiosk', 'portal.stairs', 'portal.elevator', 'portal.escalator', 'label.floor'], false, true], ['match', ['geometry-type'], ['Point'], true, false], ['!=', ['get', 'showBadge'], true]],
            layout: {
                'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
                'text-size': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 12, 22, 30],
                'text-field': ['to-string', ['get', 'text']],
            },
            paint: {
                'text-halo-blur': 0.25,
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'text-opacity': ['interpolate', ['linear'], ['zoom'], 18, 0, 18.5, 1],
                'text-halo-width': 1,
            },
        }, {
            id: '1 - security and building labels',
            type: 'symbol',
            source: ordinalSource,
            minzoom: 16,
            filter: ['all', ['match', ['get', 'category'], ['security.exit', 'security.checkpoint', 'element.securitythreshold', 'label.floor'], true, false], ['match', ['geometry-type'], ['Point'], true, false]],
            layout: {
                'text-size': ['interpolate', ['linear'], ['zoom'], 18, 14, 22, 40],
                'icon-offset': [0, -25],
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                'text-padding': 0,
                'text-offset': [0, 0],
                'icon-size': 1,
                'text-anchor': 'top',
                'text-field': ['to-string', ['get', 'text']],
            },
            paint: {
                'icon-opacity': ['interpolate', ['linear'], ['zoom'], 16.5, 0, 17, 1],
                'text-halo-blur': 1,
                'text-halo-width': 1,
                'text-color': ['get', 'textColor'],
                'text-opacity': ['interpolate', ['linear'], ['zoom'], 15, 0, 16, 1],
                'text-halo-color': 'hsl(0, 0%, 100%)',
            },
        }, {
            id: '1 - jetway label',
            type: 'symbol',
            source: 'landscape-background',
            minzoom: 16,
            filter: ['all', ['match', ['get', 'aiLayer'], ['jetways'], true, false], ['match', ['get', 'category'], ['basemap.jetwaybubble', 'jetway', 'jetway.bubble'], true, false], ['has', 'text']],
            layout: {
                'text-field': ['to-string', ['get', 'text']],
                'text-offset': [0, 0],
                'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
                'text-size': ['interpolate', ['exponential', 1.7], ['zoom'], 15, 8, 22, 200],
            },
            paint: {
                'text-color': ['get', 'textColor'],
                'text-halo-width': 0,
                'text-opacity': ['interpolate', ['linear'], ['zoom'], 18.5, 1, 19.5, 0],
            },
        }, {
            id: 'navgiation line shadow',
            type: 'line',
            source: 'navlineSource',
            filter: ['all', ['match', ['geometry-type'], ['LineString'], true, false], ['has', 'segmentType']],
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 1, 22, 60],
                'line-blur': 40,
                'line-gap-width': 0,
                'line-translate': [0, 0],
                'line-offset': -5,
                'line-color': 'hsla(0, 0%, 0%, 0.6)',
            },
        }, {
            id: 'navgiation line stroke',
            type: 'line',
            source: 'navlineSource',
            filter: ['all', ['match', ['geometry-type'], ['LineString'], true, false], ['has', 'segmentType']],
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 1, 22, 36],
                'line-color': 'hsl(222, 0%, 100%)',
                'line-gap-width': 0,
                'line-blur': 0,
                'line-translate': [0, 0],
                'line-offset': 0,
            },
        }, {
            id: 'navgiation line - walk',
            type: 'line',
            source: 'navlineSource',
            filter: ['all', ['match', ['get', 'segmentType'], ['walk'], true, false], ['match', ['geometry-type'], ['LineString'], true, false]],
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
                'line-round-limit': 0,
            },
            paint: {
                'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 1, 22, 30],
                'line-color': 'hsl(222, 83%, 53%)',
                'line-gap-width': 0,
                'line-blur': 0,
                'line-translate': [0, 0],
                'line-offset': 0,
            },
        }, {
            id: 'navgiation line - sec',
            type: 'line',
            source: 'navlineSource',
            filter: ['all', ['match', ['get', 'segmentType'], ['security'], true, false], ['match', ['geometry-type'], ['LineString'], true, false]],
            layout: {
                'line-join': 'round',
                'line-cap': 'round',
            },
            paint: {
                'line-width': ['interpolate', ['exponential', 1.5], ['zoom'], 11, 1, 22, 30],
                'line-color': 'hsl(0, 68%, 57%)',
                'line-gap-width': 0,
                'line-blur': 0,
                'line-translate': [0, 0],
                'line-offset': 0,
            },
        }, {
            id: 'navigation icon - security',
            type: 'symbol',
            source: 'navlineSource',
            filter: ['all', ['match', ['geometry-type'], ['Point'], true, false], ['match', ['get', 'badge'], ['security'], true, false]],
            layout: {
                'icon-image': ['get', 'badge'],
                'icon-size': ['interpolate', ['exponential', 1.5], ['zoom'], 13, 0.6, 22, 1],
                'icon-offset': [0, 0],
                'text-size': ['interpolate', ['exponential', 1.96], ['zoom'], 20, 18, 22, 22],
                'text-offset': [0, 2.2],
                'text-font': ['Roboto Medium', 'Arial Unicode MS Regular'],
            },
            paint: {
                'text-color': '#dc4747',
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'text-halo-width': 2,
                'text-halo-blur': 0.5,
            },
        }, {
            id: 'navigation icon - end',
            type: 'symbol',
            source: 'navlineSource',
            filter: ['all', ['match', ['geometry-type'], ['Point'], true, false], ['match', ['get', 'badge'], ['wayfinding-end'], true, false]],
            layout: {
                'icon-image': ['get', 'badge'],
                'icon-size': ['interpolate', ['exponential', 1.5], ['zoom'], 13, 0.6, 22, 1],
                'icon-offset': [0, -37],
                'text-size': ['interpolate', ['exponential', 1.96], ['zoom'], 20, 18, 22, 22],
                'text-offset': [0, 1.5],
                'text-font': ['Roboto Medium', 'Arial Unicode MS Regular'],
            },
            paint: {
                'text-color': '#4d4563',
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'text-halo-width': 0.75,
                'text-halo-blur': 0.5,
            },
        }, {
            id: 'navigation icon - start',
            type: 'symbol',
            source: 'navlineSource',
            filter: ['all', ['match', ['geometry-type'], ['Point'], true, false], ['match', ['get', 'badge'], ['wayfinding-start'], true, false]],
            layout: {
                'text-size': ['interpolate', ['exponential', 1.96], ['zoom'], 20, 18, 22, 22],
                'icon-offset': [0, -37],
                'icon-image': ['get', 'badge'],
                'text-font': ['Roboto Medium', 'Arial Unicode MS Regular'],
                'text-justify': 'right',
                'text-offset': [1, -1.5],
                'icon-size': ['interpolate', ['exponential', 1.5], ['zoom'], 13, 0.6, 22, 1],
                'text-anchor': 'left',
                'text-field': 'You are here',
            },
            paint: {
                'text-color': '#404a59',
                'text-halo-color': 'hsl(0, 0%, 100%)',
                'text-halo-width': 1,
                'text-halo-blur': 0.5,
            },
        }, {
            id: 'map notes',
            type: 'symbol',
            source: 'mapNotes',
            filter: ['all', ['match', ['geometry-type'], ['Point'], true, false], ['has', 'status']],
            layout: {
                'icon-image': ['get', 'status'],
                'icon-size': ['interpolate', ['exponential', 1.9], ['zoom'], 13.5, 0.5, 20, 1.2],
                'icon-allow-overlap': true,
                'icon-padding': 10,
            },
            paint: { 'icon-opacity': ['interpolate', ['exponential', 1.9], ['zoom'], 13.5, 0, 15, 1] },
        }, {
            id: 'selected state',
            type: 'symbol',
            source: ordinalSource,
            filter: ['match', ['geometry-type'], ['Point'], true, false],
            layout: {
                'text-size': ['interpolate', ['exponential', 1.9], ['zoom'], 0, 12, 22, 30],
                'text-allow-overlap': true,
                'icon-offset': [0, 0],
                'icon-image': ['match', ['get', 'id'], selectedIds, ['concat', '', ['get', 'category']], ''],
                'text-font': ['Open Sans SemiBold', 'Arial Unicode MS Regular'],
                'icon-allow-overlap': true,
                'text-offset': [0, 1.5],
                'text-anchor': 'top',
                'text-field': ['match', ['get', 'id'], selectedIds, ['to-string', ['get', 'text']], ''],
            },
            paint: {
                'text-halo-blur': 0.25,
                'text-halo-width': ['match', ['get', 'id'], selectedIds, 1.5, 1],
                'text-opacity': ['match', ['get', 'id'], selectedIds, 1, 0],
                'text-halo-color': ['match', ['get', 'id'], selectedIds, '#000000', '#ffffff'],
                'text-color': ['match', ['get', 'id'], selectedIds, '#FFFFFF', 'hsl(256, 0%, 0%)'],
            },
        }],
    created: '2019-04-26T20:00:12.025Z',
    id: 'cjuyi30em1c2v1fqq8bmhie6y',
    modified: '2019-04-26T20:08:09.927Z',
    draft: false,
});
export default defaultMapStyle;
